module.exports = __webpack_public_path__ + "static/media/bj.a757f8bd.svg";